//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["applicationKey"],"SetIntApplicationKey",{},1,0],[["applicationKey"],"SetNXOpenObjectApplicationKey",{},1,0],[["sourceEntities"],"AddTagSourceEntities",{},1,0],[["sourceEntity"],"AddIntSourceEntity",{},1,0],[["tagSourceEntity","intSourceEntity"],"AddTagIntPairSourceEntity",{},2,0]],[]];
SPLM.Features.TrackingData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TrackingData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;